import urlJoin from 'url-join'

// Re-export vehicle field configuration
export * from './vehicleFieldConfig'
export * from './fieldOptions'

export namespace URLs {
  // Base URLs
  export const HOME = '/'
  export const DASHBOARD = '/dashboard'

  // Vehicle management URLs
  export const VEHICLE_FIELD_MAPPING = '/field-mapping'
  export const VEHICLE_FIELD_VALUES_PREVIEW = '/field-values-preview'
  export const VEHICLE_LISTING_SETTINGS = '/vehicle-listing-settings'
  export const VEHICLE_SEGMENTATION = '/vehicle-segmentation'
  export const MEDIA_MANAGER = '/media-manager'
  export const ANALYTICS = '/analytics'

  // Settings URLs
  export const SETTINGS = '/settings'
  export const USER_PROFILE = '/user-profile'
}

export namespace APIEndpoints {
  export const GET_SEGMENTS = (accountId: string, productId: string) =>
    urlJoin(Environments.VITE_JAMS_BACKEND_URL, 'account/products', accountId, productId)

  export const SAVE_SEGMENTS = () =>
    urlJoin(
      Environments.VITE_JAMS_BACKEND_URL,
      'account/products',
      Environments.JAMS_ACCOUNT_ID,
      Environments.JAMS_PRODUCT_ID,
    )
}

export namespace Environments {
  export const VITE_JAMS_FRONTEND_URL = import.meta.env.VITE_JAMS_FRONTEND_URL as string
  export const JAMS_ACCOUNT_ID = import.meta.env.VITE_JAMS_ACCOUNT_ID as string
  export const JAMS_PRODUCT_ID = import.meta.env.VITE_JAMS_PRODUCT_ID as string
  export const VITE_JAMS_BACKEND_URL = import.meta.env.VITE_JAMS_BACKEND_URL as string
}
